import React, { useEffect, useState } from 'react'
import { Button, Card, CardContent, makeStyles } from '@material-ui/core'
import { COLORS } from 'src/utils/Themes/colors'
import Modal from 'src/components/common/Modal'
import DetailedView from 'src/components/RiskReports/PendingClaims/DetailedView'
import formatDate from 'src/utils/commonMethods/formatDate'
import GeneralPendingClaimChart from 'src/components/RiskReports/PendingClaims/GeneralPendingClaimChart'
import HealthPendingClaimChart from 'src/components/RiskReports/PendingClaims/HealthPendingClaimChart'
import {
  CLAIM_SYNOPSIS_AS_ON,
  CLAIMS_AS_ON,
  INSURANCE,
  PENDINGCLAIM_TYPE,
} from 'src/utils/constants/RiskReports'
import { MenuItem, Select } from '@mui/material'

const PendingClaims = ({
  claimCounts,
  claimsData,
  showDetailedView = true,
  type,
  date,
  employeeBenefitsData,
  nonEmployeeBenefitsData,
  financialYearOptions,
  selectedFinancialYear,
  setSelectedFinancialYear,
}) => {
  const classes = useStyles()
  const [updatedOn, setUpdatedOn] = useState('')
  const [modalOpen, setModalOpen] = useState(false)

  const handleDetailedView = () => {
    setModalOpen(true)
  }

  const CloseModal = () => {
    setModalOpen(false)
  }

  useEffect(() => {
    if (claimCounts) {
      const formattedDate = formatDate(date)
      setUpdatedOn(formattedDate)
    }
  }, [claimCounts, date])

  useEffect(() => {
    if (claimsData) {
      const formattedDate = formatDate(date)
      setUpdatedOn(formattedDate)
    }
  }, [claimsData, date])

  return (
    <div className='pendingClaimsParent'>
      <div className={classes.root}>
        {modalOpen ? (
          <Modal
            class={classes.modalClass}
            bgcolor={COLORS?.WHITE}
            ordered={modalOpen}
            width={'70%'}
            left={'15%'}
            top={'5%'}
            modelClosed={CloseModal}
          >
            <DetailedView
              closefunction={CloseModal}
              date={updatedOn}
              data={claimsData}
              type={type}
            />
          </Modal>
        ) : null}
        <Card className={classes.cardMainContainer}>
          <CardContent>
            <h2 className={classes.title}>
              {type === INSURANCE?.HEALTH ? CLAIMS_AS_ON : CLAIM_SYNOPSIS_AS_ON}
              <p className={classes.supportText}>{updatedOn}</p>
            </h2>
            <div className={classes.financialYearDropdownContainer}>
              {type == PENDINGCLAIM_TYPE?.GENERAL_FORM && (
                <Select
                  id='financialYear'
                  value={selectedFinancialYear}
                  className={classes.financialYearDropdown}
                  size='small'
                  onChange={(e) => {
                    setSelectedFinancialYear(e?.target?.value)
                  }}
                  MenuProps={{
                    sx: {
                      '& .MuiMenuItem-root': {
                        padding: '5px',
                        fontSize: '14px',
                        border: '1px solid lightgray',
                      },
                    },
                  }}
                >
                  {financialYearOptions?.map((item, index) => {
                    return (
                      <MenuItem key={index + 1} value={item?.value}>
                        {item?.text}
                      </MenuItem>
                    )
                  })}
                </Select>
              )}
            </div>
            {type === PENDINGCLAIM_TYPE?.GENERAL_FORM ? (
              <GeneralPendingClaimChart
                employeeBenefitsData={employeeBenefitsData}
                nonEmployeeBenefitsData={nonEmployeeBenefitsData}
              />
            ) : (
              <HealthPendingClaimChart data={claimCounts} />
            )}

            {showDetailedView && (
              <>
                <Button
                  id='detailedView'
                  variant='text'
                  className={classes.btnLabel}
                  onClick={handleDetailedView}
                >
                  Detailed View
                </Button>
              </>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default PendingClaims

const useStyles = makeStyles({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    borderRadius: '10px',
    textAlign: 'center',
  },
  cardMainContainer: {
    borderRadius: '10px',
    padding: '6px',
  },
  title: {
    fontSize: '18px',
    lineHeight: '22px',
    marginTop: '0px',
    color: COLORS.GREY,
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyItems: 'center',
    flexDirection: 'column',
    fontWeight: '600',
  },
  supportText: {
    marginTop: 0,
    fontSize: 17,
    fontWeight: '600',
  },
  btnLabel: {
    textTransform: 'capitalize',
    color: COLORS.LINK_COLOR_DARK,
    textDecoration: 'underline',
  },
  modalClass: {
    height: '90%',
    overflow: 'auto',
  },
  financialYearDropdown: {
    margin: '10px 0px !important',
    fontSize: '13px !important',
    borderRadius: '25px !important',
    color: '#B92250 !important',
    '& .MuiSelect-select': {
      padding: '5.5px 29px 5.5px 9px !important',
    },
  },
  financialYearDropdownContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    paddingBottom: '7px',
  },
})
